export const AGENDA = `
	query agenda($event_id: Uint) {
		agenda(event_id: $event_id) {
			id
			name
			location
			notes
			agenda_color
			start_time
			end_time
			recurring
			recurring_type
			number_of_groups
		}
	}
`;

export const AGENDA_ITEM = `
	query agendaItem($id: Uint) {
		agendaItem(id: $id) {
			id
			name
			description
			location
			image_url
			link
			notes
			agenda_color
			start_time
			end_time
			recurring
			recurring_type
			groups {
				id
				name
			}
			materials {
				id
				name
				link
				groups {
					id
					name
				}
			}
		}
	}
`;
